import config from "../configurations";
import { LOG, NOTIFY_LOG } from "../configurations/Urls";
import axios from "axios";
import Session from "../helpers/SessionHelper";
const { LOGGING_API_KEY } = config;

const SQSHelper = {
  async sendMessageToQueue(params) {
    if (!params) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.post(NOTIFY_LOG, params, {
      headers: headers,
    });
    return response;
  },

  async sendMessageToLogQueue(params) {
    if (!params) return;
    const response = await axios.post(LOG, params, {
      headers: {
        "x-api-key": LOGGING_API_KEY,
      },
    });
    return response;
  },
};
export default SQSHelper;
